// extracted by mini-css-extract-plugin
export default {"shipping-support-wrap":"User_shipping-support-wrap__AGXS1","upload-card":"User_upload-card__anhBS","upload-preview":"User_upload-preview__U4xHJ"};